import { Register, ComponentRender } from './factory';

// 组件引入
// import './components/dy-input';
import './components/dy-radio';
import './components/dy-checkbox';
// import './components/dy-cascader';
// import './components/dy-datetime';
// import './components/dy-datepicker';

export default {
    Register,
    ComponentRender,
};
